window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  hasSessionStorage: true,
  hasLocalStorage: true,
};

theme.productIds = [];

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
  document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
  document.addEventListener("shopify:section:select", this._onSelect.bind(this));
  document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
  document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
  document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor, scope) {
    const id = container.getAttribute("data-section-id");
    const type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    // If custom scope passed, check to see if instance
    // is already initialized so we don't double up
    if (scope) {
      const instanceExists = this._findInstance(id);
      if (instanceExists) {
        this._removeInstance(id);
      }
    }

    // If a section fails to init, handle the error without letting all subsequest section registers to fail
    try {
      let instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container,
      });
      this.instances.push(instance);
    } catch (e) {
      console.error(e);
    }
  },

  _findInstance: function (id) {
    for (let i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  _removeInstance: function (id) {
    const i = this.instances.length;
    let instance;

    while (i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  _onSectionLoad: function (evt, subSection, subSectionId) {
    if (theme && theme.initGlobals) {
      theme.initGlobals();
    }

    const container = subSection ? subSection : evt.target;
    const section = subSection ? subSection : evt.target.querySelector("[data-section-id]");

    if (!section) {
      return;
    }

    this._createInstance(section);

    const instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    // Check if we have subsections to load
    const haveSubSections = container.querySelectorAll("[data-subsection]");
    if (haveSubSections.length) {
      this.loadSubSections(container);
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === "function") {
      instance.onLoad(evt);
    }

    // Force editor to trigger scroll event when loading a section
    setTimeout(function () {
      window.dispatchEvent(new Event("scroll"));
    }, 200);
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      const isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  loadSubSections: function (scope) {
    if (!scope) {
      return;
    }

    const sections = scope.querySelectorAll("[data-section-id]");

    sections.forEach((el) => {
      this._onSectionLoad(null, el, el.dataset.sectionId);
    });
  },

  _onSelect: function (evt) {
    const instance = this._findInstance(evt.detail.sectionId);

    if (typeof instance !== "undefined" && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    const instance = this._findInstance(evt.detail.sectionId);

    if (typeof instance !== "undefined" && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    const instance = this._findInstance(evt.detail.sectionId);

    if (typeof instance !== "undefined" && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    const instance = this._findInstance(evt.detail.sectionId);

    if (typeof instance !== "undefined" && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor, scope) {
    this.constructors[type] = constructor;

    let sections = document.querySelectorAll('[data-section-type="' + type + '"]');

    if (scope) {
      sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
    }

    sections.forEach(
      function (container) {
        this._createInstance(container, constructor, scope);
      }.bind(this)
    );
  },

  reinit: function (section) {
    for (let i = 0; i < this.instances.length; i++) {
      const instance = this.instances[i];
      if (instance["type"] === section) {
        if (typeof instance.forceReload === "function") {
          instance.forceReload();
        }
      }
    }
  },
});

theme.checkBtnProduct = (function () {
  function Product(container) {
    this.container = container;
    const sectionId = (this.sectionId = container.getAttribute("data-section-id"));
    const productId = (this.productId = container.getAttribute("data-product-id"));

    this.init();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    init: function () {
      this.buildCart();
      this.clickBtn();
    },
    clickBtn: function () {
      const id = this.container.getAttribute("data-product-id");
      const btns = this.container.querySelectorAll(".AddToCart");

      if (!id) return;
      if (!theme.productSelectIds && typeof theme.productSelectIds == "undefined") return;

      const diff = this.filterByID(theme.productIds, theme.productSelectIds);

      if (diff.length > 0) {
        diff.forEach((i) => {
          const df = theme.productIds.indexOf(i);
          theme.productIds.splice(df, 1);
        });
      }

      theme.productSelectIds.forEach((item) => {
        if (id == item) {
          btns.forEach((btn) => {
            btn.addEventListener("click", () => {
              const i = theme.productIds.indexOf(id);
              if (i > -1) theme.productIds.splice(i, 1);
              theme.productIds.unshift(id);

              if (theme.config.hasLocalStorage) {
                window.localStorage.setItem("productIds", JSON.stringify(theme.productIds));
                this.buildCart();
              }
            });
          });
        }
      });
    },

    filterByID: function (arr1, arr2) {
      return arr1.filter((i) => !arr2.includes(i));
    },

    buildCart: function () {
      theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
    },

    cartMarkup: function (html) {
      const markup = this._parseProductHTML(html);
      // const cartForm = new theme.CartForm(markup.form);
      const items = markup.items;
      if (items !== null) {
        const arrItems = items.querySelectorAll(".line-item");
        const count = parseInt(items.dataset.count);
        const headerCartCount = document.querySelector(".CartCount");
        const qty = 1;
        const arrKeyProducts = [];

        arrItems.forEach((item) => {
          theme.productIds.forEach((id) => {
            if (id == item.dataset.itemProductId) {
              const inputQuantity = item.querySelector("input.quantity-selector");
              if (inputQuantity.value > 0) {
                const key = item.dataset.key;
                arrKeyProducts.push(key);
              }
            }
          });
        });

        const cartForm = new theme.CartForm(markup.form, arrKeyProducts, qty);

        setTimeout(() => {
          if (headerCartCount !== null) headerCartCount.innerHTML = count;
        }, 250);
      }
    },

    /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
    _parseProductHTML: function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      return {
        form: doc.querySelector("#cartform"),
        items: doc.querySelector(".cart-table tbody"),
      };
    },
  });

  return Product;
})();

theme.checkPromoProducts = (function () {
  function Checkout(container) {
    this.container = container;
    const sectionId = (this.sectionId = container.getAttribute("data-section-id"));
    const productId = (this.productId = container.getAttribute("data-product-id"));

    this.init();
  }

  Checkout.prototype = Object.assign({}, Checkout.prototype, {
    init: function () {
      this.buildCart();
    },

    filterByID: function (arr1, arr2) {
      return arr1.filter((i) => !arr2.includes(i)).concat(arr2.filter((i) => !arr1.includes(i)));
    },

    buildCart: function () {
      if (!theme.productSelectIds && typeof theme.productSelectIds == "undefined") return;

      const diff = this.filterByID(theme.productIds, theme.productSelectIds);

      if (diff.length > 0) {
        diff.forEach((i) => {
          const df = theme.productIds.indexOf(i);
          theme.productIds.splice(df, 1);
        });
      }
      theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
    },

    cartMarkup: function (html) {
      const markup = this._parseProductHTML(html);
      // const cartForm = new theme.CartForm(markup.form);
      const items = markup.items;
      if (items !== null) {
        const arrItems = items.querySelectorAll(".line-item");
        const count = parseInt(items.dataset.count);
        const headerCartCount = document.querySelector(".CartCount");
        const qty = 1;
        const arrIdProducts = [];
        const arrKeyProducts = [];
        const arrDublKeyProducts = [];
        const arrQtyProducts = [];
        const countItems = {};
        const countWhatItems = [];

        arrItems.forEach((item) => {
          const id = item.dataset.itemProductId;
          countItems[id] = countItems[id] ? countItems[id] + 1 : 1;
        });

        const resultDublicate = Object.keys(countItems).filter((item) => countItems[item] > 1);

        arrItems.forEach((item, index) => {
          arrIdProducts.push(item.dataset.itemProductId);

          if (resultDublicate.length > 0) {
            resultDublicate.forEach((id) => {
              if (item.dataset.itemProductId === id) {
                const i = countWhatItems.indexOf(item.dataset.itemProductId);
                if (i > -1) countWhatItems.splice(i, 1);
                countWhatItems.unshift(item.dataset.itemProductId);
              }
            });
          }

          theme.productIds.forEach((id) => {
            if (id == item.dataset.itemProductId) {
              const inputQuantity = item.querySelector("input.quantity-selector");
              if (inputQuantity.value > 1) {
                const key = item.dataset.key;

                arrKeyProducts.push(key);
                arrQtyProducts.push(inputQuantity.value);
              }
            }
          });
        });

        if (resultDublicate.length > 0) {
          countWhatItems.forEach((id) => {
            const key = arrItems[arrIdProducts.indexOf(id)].dataset.key;
            arrDublKeyProducts.push(key);
          });

          const cartDelDublicateForm = new theme.CartForm(markup.form, arrDublKeyProducts, 0);

          setTimeout(() => {
            location.reload();
          }, 600);
        }

        const cartForm = new theme.CartForm(markup.form, arrKeyProducts, qty);

        arrQtyProducts.forEach((int) => {
          if (int > 1) {
            setTimeout(() => {
              location.reload();
            }, 600);
          }
        });

        setTimeout(() => {
          if (headerCartCount !== null) headerCartCount.innerHTML = count;
        }, 250);
      }
    },

    /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
    _parseProductHTML: function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      return {
        form: doc.querySelector("#cartform"),
        items: doc.querySelector(".cart-table tbody"),
      };
    },
  });

  return Checkout;
})();

theme.CartForm = (function () {
  function CartForm(form, keys, qty) {
    if (!form) {
      return;
    }
    this.form = form;
    this.location = form.dataset.location;

    setTimeout(() => {
      keys.forEach((key) => {
        this.quantityChanged(key, qty);
      });
    }, 250);
  }

  CartForm.prototype = Object.assign({}, CartForm.prototype, {
    quantityChanged: function (key, qty) {
      theme.cart
        .changeItem(key, qty)
        .then(
          function (cart) {
            // if (cart.item_count > 0) {}
            this.buildCart();

            document.dispatchEvent(
              new CustomEvent("cart:updated", {
                detail: {
                  cart: cart,
                },
              })
            );
          }.bind(this)
        )
        .catch(function (XMLHttpRequest) {});
    },
  });

  return CartForm;
})();

theme.cart = {
  getCartProductMarkup: function () {
    let url = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
    url = url.indexOf("?") === -1 ? url + "?view=ajax" : url + "&view=ajax";

    return fetch(url, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (response) {
      return response.text();
    });
  },

  changeItem: function (key, qty) {
    return this._updateCart({
      url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
      data: JSON.stringify({
        id: key,
        quantity: qty,
      }),
    });
  },
  _updateCart: function (params) {
    return fetch(params.url, {
      method: "POST",
      body: params.data,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then(function (cart) {
        return cart;
      });
  },
};

theme.isStorageSupported = function (type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "test";
  let storage;
  if (type === "session") {
    storage = window.sessionStorage;
  }
  if (type === "local") {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

/*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
theme.config.hasSessionStorage = theme.isStorageSupported("session");
theme.config.hasLocalStorage = theme.isStorageSupported("local");

if (theme.config.hasLocalStorage) {
  const recentIds = window.localStorage.getItem("productIds");
  if (recentIds && recentIds !== "undefined") {
    theme.productIds = JSON.parse(recentIds);
  }
}

/*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
function DOMready(callback) {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

DOMready(function () {
  theme.sections = new theme.Sections();

  theme.sections.register("product-main", theme.checkBtnProduct);
  theme.sections.register("checkout", theme.checkPromoProducts);
});
